module.exports = __webpack_public_path__ + "static/media/battery-quarter.2a153773.svg";